import { __decorate } from "tslib";
import { AsnType, AsnTypeTypes, AsnProp, BitString } from "@peculiar/asn1-schema";
import { id_ntQWAC } from "./oids";
export const id_TypeRelationship = `${id_ntQWAC}.5`;
let TypeRelationship = class TypeRelationship {
    constructor(params = {}) {
        this.DNBvsDNO = new BitString(0);
        this.DNBvsDNT = new BitString(0);
        this.DNOvsDNT = new BitString(0);
        Object.assign(this, params);
    }
};
__decorate([
    AsnProp({ type: BitString, context: 0 })
], TypeRelationship.prototype, "DNBvsDNO", void 0);
__decorate([
    AsnProp({ type: BitString, context: 1 })
], TypeRelationship.prototype, "DNBvsDNT", void 0);
__decorate([
    AsnProp({ type: BitString, context: 2 })
], TypeRelationship.prototype, "DNOvsDNT", void 0);
TypeRelationship = __decorate([
    AsnType({ type: AsnTypeTypes.Sequence })
], TypeRelationship);
export { TypeRelationship };
